import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AlertControlService } from './alert-control.service';
@Injectable()
export class ContainerService {


  constructor(private _alert: AlertControlService) {
  }
  // Observable encargado de visualización de container superpuesto
  _stateContainerResource = new BehaviorSubject<string>('');
  observableStateContainer$ = this._stateContainerResource.asObservable();

  // actualizamos valor, este valor se actualizará en todos los oyentes
  changeStateContainer(measure: string) {
    this._alert._showAlertResouce.next(null);
    this._stateContainerResource.next(measure);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/container.service.ts